import type { TaxRates } from '~/repository/modules/tax';

export const useTaxStore = defineStore('tax', () => {
  const { $api } = useNuxtApp();
  
  // Initialize default tax rates
  const rates = ref<TaxRates>({
    post: 0,
    subscription: 0
  });

  // Flag indicating if data has been loaded
  const isLoaded = ref(false);

  // Fetch tax rates
  async function fetchRates() {
    try {
      // Fetch both rates in parallel
      const [postRate, subscriptionRate] = await Promise.all([
        $api.tax.getPostRate().catch((err) => {
          return 0;
        }),
        $api.tax.getSubscriptionRate().catch((err) => {
          return 0;
        })
      ]);
      
      // Update rates in store
      rates.value = {
        post: postRate || 0,
        subscription: subscriptionRate || 0
      };
      
      isLoaded.value = true;
    } catch (error) {

      // Set default values in case of error
      rates.value = {
        post: 0,
        subscription: 0
      };
      isLoaded.value = true;
    }
  }

  return {
    rates,
    isLoaded,
    fetchRates
  };
});
